module.exports = {
      id: "dominio-personalizado-usage",
      viewBox: "0 0 106 86",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#dominio-personalizado",
      toString: function () {
        return this.url;
      }
    }